"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _HeaderFinancing = _interopRequireDefault(require("./HeaderFinancing/HeaderFinancing"));

var _HeaderMenu = require("./HeaderMenu.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderMenu = function HeaderMenu(_ref) {
  var partner = _ref.partner,
      activeMenuName = _ref.activeMenuName;
  return _react.default.createElement(_HeaderMenu.HeaderItems, {
    "data-qa": "header-menu"
  }, _react.default.createElement(_HeaderMenu.HeaderItemButton, {
    dataCvTest: "headerSearchLink",
    href: "/cars",
    target: "_self",
    isActive: activeMenuName === 'search' || activeMenuName === 'cars'
  }, "Search Cars"), _react.default.createElement(_HeaderMenu.HeaderItemButton, {
    dataCvTest: "headerTradesLink",
    href: "/trades",
    target: "_self",
    isActive: activeMenuName === 'trades'
  }, "Sell/Trade"), partner && partner.partnerVanityUrlName && partner.partnerVanityUrlName !== 'notused' ? _react.default.createElement(_HeaderMenu.HeaderItemButton, {
    dataCvTest: "headerFinancePartnerLink",
    href: "/learn-financing",
    target: "_self",
    isActive: activeMenuName === 'finance'
  }, "financing") : _react.default.createElement(_HeaderFinancing.default, {
    isActive: activeMenuName === 'finance'
  }));
};

HeaderMenu.defaultProps = {
  partner: {
    partnerVanityUrlName: 'notused'
  },
  activeMenuName: null
};
var _default = HeaderMenu;
exports.default = _default;
module.exports = exports.default;